$(function() {
$(document).on('click', '[data-header-drawer-toggle]', function (e) {
      this.login_drawer = $('[data-login-drawer]');
      this.login_drawer.toggleClass('is-visible');
       $('.theme-ajax-cart.is-visible').removeClass('is-visible');
       e.stopPropagation()
      });
var top_bar = $('.top-bar').innerHeight();
var header = $('.header').innerHeight();
var plus = top_bar + header
  $('.logout_modal').css('top', `${plus}px`)

function height(e) {
  var moblie_header = $('.mobile-header').innerHeight();
    if($(window).width() < 798){
      $('.logout_modal').css('top', `${moblie_header}px`)
    }
  }
  height();

function width(e) {
    var width = $(document).innerWidth();
      $('.logout_modal').css('left', `${width - 183}px`)
  }
  width();
  height();
  $(window).resize(function(){
    height();
   width();
  });

  // sticky header
$( window ).on( "scroll", function() {
 	var windowpos = $(window).scrollTop();
  	if (windowpos >= 100) {
      const headerHeight = $('.header-sticky-wrapper.is-sticky').outerHeight();
      $('.logout_modal').css('top', `${headerHeight}px`);
      $('.logout_modal').css('position', 'fixed');
	}
  else{
      var top_bar = $('.top-bar').innerHeight();
      var header = $('.header').innerHeight();
      var plus = top_bar + header
      $('.logout_modal').css('top', `${plus}px`)
      height();
  }
});
$(document).on("click", function(e) {
    if ($(e.target).is('.logout_modal') === false) {
      $(".logout_modal").removeClass("is-visible");
    }
  });
  });